var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"itemId":_vm.fileId},on:{"loaded":_vm.afterload}},[(_vm.id)?_c('MarketContent',{attrs:{"id":_vm.id,"name":_vm.name}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }